import script from "./index-info.vue?vue&type=script&setup=true&lang=js"
export * from "./index-info.vue?vue&type=script&setup=true&lang=js"

import "./index-info.vue?vue&type=style&index=0&id=a41c208e&scoped=true&lang=less"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a41c208e"]])

export default __exports__